import { hashCode } from "@/helpers/Misc";
import { Guid } from "@/helpers/Component";
import Validators from "./ValidatorLib";
import type {
  ValidatorFunction,
  IValidatorDto,
  IValidatorObject,
  IValidationErrorDto,
  IValidatorObjectData,
  IValidatorResult,
} from "@/types/FormEngine/validation";

export default class Validation {
  public static validatorLib = Validators as { [key: string]: ValidatorFunction };
  public static validatorResolverHash = "";
  static newValidator(
    data: any = {},
    validator: ValidatorFunction = (data?: IValidatorDto) => {
      return {
        isValid: true,
        message: "",
        navigationData: "",
      };
    }
  ): IValidatorObject {
    let guid: Guid = Guid.newGuid();
    return {
      data: data,
      validator: validator,
      guid: guid.toString(),
    } as IValidatorObject;
  }
  static setValidatorResolverHash() {
    this.validatorResolverHash = hashCode(this.validatorResolver.toString()).toString();
  }

  static setValidator(validatorObject: IValidatorObject, validatorIdentifier: string | null = null): void {
    window.FormEngine.events.subscribe(
      window.FormEngine.events.list.VALIDATE,
      this.validatorResolver,
      validatorIdentifier,
      validatorObject.validatorName,
      validatorObject
    );
  }

  static removeValidator(validatorName: string, specifier?: String) {
    let callbackHashCode = (this.validatorResolverHash + (validatorName ? "-" + validatorName : "")) as string;
    if (specifier) {
      return window.FormEngine.events.removeSubscriber(window.FormEngine.events.list.VALIDATE, specifier, callbackHashCode);
    } else {
      return window.FormEngine.events.removeSubscriber(window.FormEngine.events.list.VALIDATE, callbackHashCode);
    }
  }

  static validatorResolver(data: IValidatorDto) {
    let validatorObject = this as any;

    data._validatorObject = validatorObject;
    let results = validatorObject.validator(data);

    if (!Array.isArray(results)) {
      if (!results) {
        results = {
          validatorGuid: validatorObject.guid,
        };
      } else {
        results.validatorGuid = validatorObject.guid;
        results.targetId = data.control.identifier;
        results.control = data.control;
        //console.log("Validator resolver => ",results,data);
      }
      results = new Array(results);
    }
    return results;
  }
  public static resolveValidationResults(validationResults: [IValidatorResult], fillErrorBag: boolean = true, fillControlErrors: boolean = true) {
    for (let result of validationResults) {
      if (!result.isValid) {
        let errorDto = this.validatorResultToErrorDto(result);
        if (fillErrorBag) {
          window.FormEngine.form.errorBag.pushError(errorDto);
        }
        if (fillControlErrors) {
          result.control.pushError(errorDto);
        }
      } else {
        window.FormEngine.form.errorBag.removeError(result, fillErrorBag, fillControlErrors);
        result.control.removeError(result);
      }
      if (result.control.state.parent && !result.control.mtdt.IsTableDetailElement) {
        result.control.state.parent.touch(true);
      }
    }
  }
  public static validatorResultToErrorDto(result: IValidatorResult) {
    let errorDto: IValidationErrorDto = {
      targetId: result.targetId,
      validatorGuid: result.validatorGuid,
      message: result.message,
    } as IValidationErrorDto;
    if (result.targetId) {
      errorDto.control = window.FormEngine.form.getTargetable(result.targetId);
      errorDto.navigationData = result.navigationData;
    }
    if (result.errorBagMessage) {
      errorDto.errorBagMessage = result.errorBagMessage;
    }

    return errorDto;
  }
  static newValidatorDto(data: { [key: string]: any } = {}, control: any | null = null): IValidatorDto {
    if (control) {
      return {
        validableId: control.identifier,
        control: control,
        from: control.state.previousValue,
        to: control.getValue(),
        data: data,
      } as IValidatorDto;
    } else {
      return {
        data: data,
      } as IValidatorDto;
    }
  }

  static setValidatorFromLib(validatorName: string, data: IValidatorObjectData) {
    let validator = this.newValidator(data, this.validatorLib[validatorName]);
    validator.validatorName = validatorName;
    this.setValidator(validator, data.control.identifier ? data.control.identifier : null);
  }

  static validateAll() {
    //CONTROLS VALIDATION
    window.FormEngine.form.errorBag.resetErrors();
    let validationResults: Array<IValidatorResult> = [];
    let validity = true;
    window.FormEngine.events.publish(window.FormEngine.events.list.VALIDATE, {});
    window.FormEngine.form.walkTreeWith(window.FormEngine.structure.tree, function (control: any) {
      if (!control.state.hidden) {
        validationResults.push(control.validate(control.fillErrorBagComputed));
        if (!control.state.isValid) {
          //console.log("validity problem");
          validity = false;
        }
      }
    });
    return validationResults;
    //GLOBAL VALIDATION
  }
}
